import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { DealerLicensure, DealerLicensureResult } from "../models/dealer.licensure.interface";
import { ReportService } from "../services/report.service";
import { FileService } from "../../shared/services/file.service";
import { Dealer } from '../../shared/models/dealer.interface';
import { DealerService } from '../../dealer/services/dealer.service';
import { MatDialog } from '@angular/material/dialog';
import { AbstractReportComponent } from '../abstract.report.component';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-dealer-licensure',
  templateUrl: './dealer-licensure.component.html',
  styleUrls: ['./dealer-licensure.component.scss']
})
export class DealerLicensureComponent extends AbstractReportComponent implements OnInit {

  report: DealerLicensureResult = null;
  parameters: DealerLicensure = {
    dealer_ID: null
  } as DealerLicensure;

  dealer: Dealer;
  dealers: Dealer[];

  isRequesting: boolean = false;

  constructor(@Inject(LOCALE_ID) locale: string,
    deviceDetectorService: DeviceDetectorService,
    dialog: MatDialog, private dealerService: DealerService, private fileService: FileService,
    private reportService: ReportService) {
    super(locale, dialog, deviceDetectorService);
  }

  ngOnInit() {
    this.dealerService.getList()
      .subscribe({
        next: (data) => {
          this.dealers = data;
          this.loadReport();
        }
      });
  }

  renderReport() {
    this.getReportFormat()
      .subscribe(formatData => {
        if (formatData == null) return;

        this.isRequesting = true;

        this.dealerService.getDealerLicensureExport(this.parameters.dealer_ID, formatData.format)
          .subscribe({
            next: (data) => {
              this.isRequesting = false;
              this.fileService.downloadFile(data, 'DealerLicensure' + formatData.extension);
            }
          });
      });
  }

  loadReport() {
    // wait until dropdowns loaded
    if (this.dealers == null)
      return;

    this.isRequesting = true;
    this.dealer = this.dealers.find(s => s.dealer_ID == this.parameters.dealer_ID);

    this.dealerService.getDealerLicensureReport(this.parameters.dealer_ID)
      .subscribe({
        next: (data) => {
          this.report = data;
          this.isRequesting = false;
        }
      });
  }
}
